export default __webpack_public_path__ + "static/media/goshoppi6.70261319.png";